export default __webpack_public_path__ + "static/media/compliances_highlighted.a9bbdd0e.svg";